// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"681":"26ddc6f3","3977":"26ddc6f3","4537":"26ddc6f3","9559":"26ddc6f3","9799":"26ddc6f3"}[chunkId] + ".chunk.css";
};